<template>
  <div
    ref="popupRef"
    class="flex h-full w-full flex-row items-center justify-end gap-x-2"
  >
    <!-- Trigger button -->

    <div class="flex items-center justify-center gap-x-4 py-2">
      <button
        @click="isOpen = !isOpen"
        class="relative flex cursor-pointer items-center justify-center gap-x-2"
      >
        <Icon
          v-if="filterBy !== null"
          name="clear"
          type="filled"
          class="cursor-pointer text-base font-medium"
          @click="$emit('filterBy', null)"
        >
        </Icon>

        <span class="text-sm font-medium capitalize">{{
          filterBy?.replaceAll('_', ' ') ?? __('Filter by')
        }}</span>

        <Icon
          name="keyboard_arrow_down"
          type="filled"
          class="text-base font-medium"
        ></Icon>

        <!-- Popup menu -->
        <transition
          enter-active-class="transition-all duration-150 ease-out"
          enter-from-class="opacity-0 scale-95"
          enter-to-class="opacity-100 scale-100"
          leave-active-class="transition-all duration-100 ease-in"
          leave-from-class="opacity-100 scale-100"
          leave-to-class="opacity-0 scale-95"
        >
          <div
            v-if="isOpen"
            class="absolute right-0 top-6 z-50 mt-2 w-40 rounded-lg border bg-white shadow-lg"
          >
            <ul class="flex flex-col text-sm text-gray-700">
              <li>
                <button
                  @click.stop="
                    $emit('filterBy', 'pending');
                    isOpen = false;
                  "
                  class="block w-full cursor-pointer rounded px-3.5 py-2 text-left transition-colors duration-150 hover:bg-gray-100"
                >
                  {{ __('Pending') }}
                </button>
              </li>
              <li>
                <button
                  @click.stop="
                    $emit('filterBy', 'in progress');
                    isOpen = false;
                  "
                  class="block w-full cursor-pointer rounded px-3.5 py-2 text-left transition-colors duration-150 hover:bg-gray-100"
                >
                  {{ __('In progress') }}
                </button>
              </li>
              <li>
                <button
                  @click.stop="
                    $emit('filterBy', 'delivered');
                    isOpen = false;
                  "
                  class="block w-full cursor-pointer rounded px-3.5 py-2 text-left transition-colors duration-150 hover:bg-gray-100"
                >
                  {{ __('Delivered') }}
                </button>
              </li>
              <li>
                <button
                  @click.stop="
                    $emit('filterBy', 'cancelled');
                    isOpen = false;
                  "
                  class="block w-full cursor-pointer rounded px-3.5 py-2 text-left transition-colors duration-150 hover:bg-gray-100"
                >
                  {{ __('Canceled') }}
                </button>
              </li>
            </ul>
          </div>
        </transition>
      </button>
    </div>
  </div>
</template>

<script setup>
  import { onMounted, onUnmounted, ref } from 'vue';

  import { __ } from '@/helpers';
  import Icon from '@/components/global/Icon.vue';

  const props = defineProps({
    filterBy: {
      type: String,
      default: 'Filter by'
    }
  });
  const emit = defineEmits([
    'listed',
    'unlisted',
    'in_stock',
    'low_stock',
    'out_of_stock',
    'filterBy'
  ]);

  const isOpen = ref(false);

  const popupRef = ref(null);

  const handleClickOutside = (e) => {
    if (popupRef.value && !popupRef.value.contains(e.target)) {
      isOpen.value = false;
    }
  };

  onMounted(() => {
    document.addEventListener('click', handleClickOutside);
  });

  onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside);
  });
</script>
